<template>
    <div>
        <v-row class="fill-height">
            <v-col>
                <v-sheet height="38">
                    <v-toolbar flat>
                        <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday"> Текущий месяц </v-btn>
                        <v-btn fab text small color="grey darken-2" @click="prev">
                            <v-icon small> mdi-chevron-left </v-icon>
                        </v-btn>
                        <v-btn fab text small color="grey darken-2" @click="next">
                            <v-icon small> mdi-chevron-right </v-icon>
                        </v-btn>
                        <v-toolbar-title v-if="$refs.calendar">
                            {{ $refs.calendar.title }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </v-sheet>
                <v-sheet height="660px">
                    <v-calendar
                        ref="calendar"
                        v-model="focus"
                        color="primary"
                        locale="ru-RU"
                        :weekdays="weekday"
                        :events="events"
                        :event-color="getEventColor"
                        :type="type"
                        @click:event="showEvent"
                        @click:more="viewDay"
                        @click:date="viewDay"
                        @change="updateRange"
                    ></v-calendar>
                </v-sheet>
            </v-col>
        </v-row>

        <v-dialog v-model="dialog" persistent width="30vw">
            <template v-slot:activator="{ on, attrs }">
                <v-btn text color="white" dark v-bind="attrs" v-on="on"> Добавить </v-btn>
            </template>

            <v-card>
                <v-card-title>
                    <span class="headline">Создать план на {{ formated_date(new_date) }}</span>
                </v-card-title>

                <v-card-text> </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">Закрыть</v-btn>
                    <v-btn color="warning" dark @click="save()">Создать</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'archive-calendar',
    data: () => ({
        calendar: null,
        date_for_modal: null,
        dialog: false,
        new_date: '',
        focus: '',
        type: 'month',
        typeToLabel: {
            month: 'Month',
            week: 'Week',
            day: 'Day',
            '4day': '4 Days',
        },
        events: [],
        
        ex4: [],
        selectedEvent: {},
        selectedElement: null,
        selectedElement_2: null,
        selectedOpen: false,
        selectedOpen_2: false,
        events: [],
        weekday: [1, 2, 3, 4, 5, 6, 0],
        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
        edit_calendar: false,
        month: new Date().getMonth(),
        number: 1,
        current_year: new Date().getFullYear(),
        current_month: new Date().getMonth(),
    }),
    mounted() {
        this.$refs.calendar.checkChange()
    },

    methods: {
        formated_date(date) {
            return new Date(date).toLocaleDateString('ru-RU')
        },
        ...mapActions(['load_archives', 'create_plan']),

        save() {
            if (!this.new_date) return false

            this.create_plan({ date: this.new_date })
                .then((res) => {
                    this.dialog = false
                    this.updateRange()
                })
                .catch((err) => {
                    console.log(err.message)
                })
        },

        viewDay({ date }) {
            const xx = this.get_archives.find((plan) => plan.date == date)

            if (xx) this.$router.push(`/plans/${date}`)
            else {
                this.new_date = date
                this.dialog = true
            }
            return false
        },
        getEventColor(event) {
            return event.color
        },
        setToday() {
            this.current_month = this.month
            this.number = 1

            this.load_archives({
                month: String(this.current_month + this.number).padStart(2, '0'),
                year: this.current_year,
            }).then((res) => {
                this.focus = ''
            })
        },
        prev() {
            this.number -= 1

            const xx = this.current_month + this.number

            if (xx == 0) {
                this.current_month = 11
                this.number = 1
                this.current_year -= 1
            }

            this.load_archives({
                month: String(this.current_month + this.number).padStart(2, '0'),
                year: this.current_year,
            }).then((res) => {
                this.$refs.calendar.prev()
            })

            // this.$refs.calendar.prev()
            // this.updateRange()
        },
        next() {
            this.number += 1

            const xx = this.current_month + this.number

            if (xx > 12) {
                this.current_month = 0
                this.number = 1
                this.current_year += 1
            }

            this.load_archives({
                month: String(this.current_month + this.number).padStart(2, '0'),
                year: this.current_year,
            }).then((res) => {
                this.$refs.calendar.next()
            })
        },
        showEvent({ nativeEvent, event }) {
            console.log('nativeEvent', nativeEvent)
            console.log('event', event)

            this.$router.push(`${event.href}`)
            return false
            const open = () => {
                this.selectedEvent = event
                this.selectedElement = nativeEvent.target
                requestAnimationFrame(() => requestAnimationFrame(() => (this.selectedOpen = true)))
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
                open()
            }

            nativeEvent.stopPropagation()
        },
        updateRange() {
            this.events = []
            
            this.get_archives.forEach((plan) => {
                this.events.push({
                    name: 'посмотреть архив',
                    start: new Date(plan.date),
                    color: plan.status == 'open' ? 'orange' : 'grey',
                    timed: false,
                    href: `/archive/${plan.date}`,
                })
            })

            return
        },
        rnd(a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a
        },
    },
    watch: {
        get_archives(val, oldVal) {
            this.updateRange()
        },
    },
    computed: {
        ...mapGetters(['get_archives', 'get_statistic_by_id']),
    },
    beforeMount() {
        this.load_archives({ month: String(this.current_month + this.number).padStart(2, '0'), year: this.current_year })
    },
}
</script>

<style scoped>
.v-menu__content {
    top: 300px !important;
    left: 700px !important;
}

.pl-1 {
    text-align: center;
}
</style>
